var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0a10 10 0 0 0-7.068 2.888A9.74 9.74 0 0 0 0 9.868a9.74 9.74 0 0 0 2.932 6.98A10 10 0 0 0 10 19.736a10 10 0 0 0 7.068-2.888A9.74 9.74 0 0 0 20 9.868a9.74 9.74 0 0 0-2.932-6.98A10 10 0 0 0 10 0m0 18.418c-4.787 0-8.681-3.838-8.681-8.55S5.213 1.318 10 1.318s8.681 3.838 8.681 8.55-3.894 8.55-8.681 8.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BA84",
    stroke: "currentColor",
    d: "M10.07 9.846v.246l.196.15 3.74 2.879a.16.16 0 0 1-.1.287.15.15 0 0 1-.092-.031l-.002-.002-4.005-3.077-.003-.002c-.026-.02-.052-.06-.052-.124V4.158c0-.088.07-.159.16-.159.088 0 .159.07.159.16z"
  })));
};
export default SvgClock;